import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { GoTriangleRight } from "react-icons/go";
import { getParentDadorChildren } from "../../../../api/modules";
import { useSelector } from "react-redux";
import { COLOR_PRIMARY } from "../../../../constants/Colors";
import CustomItemList from "../../components/molecules/CustomItemList ";

const BadgeLog = styled(Badge)`
  background-color: ${COLOR_PRIMARY};
  color: white;
  border-radius: 5px !important;
  text-align: center;
  display: inline-block;
  padding: 0px 20px;
`;

const ContainerList = styled.div`
  overflow-y: overlay;
  padding-right: 10px;
`;

const DivEmpty = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const getValidationStatus = (validate_email, validate_phone) => {
  if (validate_email && validate_phone) return "Validado";
  if (validate_email && !validate_phone) return "Validar teléfono";
  if (!validate_email && validate_phone) return "Validar email";
  return "No validado";
};

const getStatusString = (status) => {
  switch (status) {
    case "1":
      return "Habilitado";
    case "2":
      return "Eliminado";
    case "3":
      return "Deshabilitado";
    default:
      return "Habilitado";
  }
};

function ParentChildren() {
  const spinner = useSelector((state) => state.appReducer.isLoading);
  const history = useHistory();
  const [children, setChildren] = useState([]);

  const fetchChildren = async () => {
    const { children = [] } = await getParentDadorChildren();
    setChildren(children);
  };

  useEffect(() => {
    fetchChildren();
  }, []);

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col md="12">
          <h1 className="text-primary h3 font-weight-bold">Usuarios</h1>
          <p className="text-muted mb-0">
            Cuentas activas asociadas al mismo CUIT.
          </p>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <ContainerList>
            {children.length > 0 ? (
              children.map((item, index) => (
                <CustomItemList
                  noIcon
                  onClick={() => history.push("/app/billing-parent-dador")}
                  key={item._id || index}
                  className={"p-30"}
                >
                  <Row>
                    <Col
                      xs="12"
                      md="3"
                      className="d-flex justify-content-center p-0"
                    >
                      <BadgeLog
                        as="small"
                        className={`my-2 ${
                          item.validate_email && item.validate_phone
                            ? ""
                            : "bg-danger"
                        }`}
                      >
                        {getValidationStatus(
                          item.validate_email,
                          item.validate_phone,
                        )}
                      </BadgeLog>
                    </Col>
                    <Col
                      xs="12"
                      md="3"
                      className="d-flex justify-content-center p-0"
                    >
                      <BadgeLog as="small" className="my-2">
                        {getStatusString(item.status)}
                      </BadgeLog>
                    </Col>
                    <Col
                      xs="12"
                      md="3"
                      className="d-flex justify-content-center p-0"
                    >
                      <BadgeLog as="small" className="my-2">
                        Activos: {item.active_trips || 0}
                      </BadgeLog>
                    </Col>
                    <Col
                      xs="12"
                      md="3"
                      className="d-flex justify-content-center p-0"
                    >
                      <BadgeLog as="small" className="my-2">
                        Finalizados: {item.finished_trips || 0}
                      </BadgeLog>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3" className="text-center">
                      <small>
                        <p className="text-primary text-center mb-1">
                          Razón social
                        </p>
                      </small>
                      <p className="h5 font-weight-bold mt-2">
                        {item.reason || "Sin dato"}
                      </p>
                    </Col>
                    <Col md="2" className="text-center">
                      <small>
                        <p className="text-primary text-center mb-1">Nombre</p>
                      </small>
                      <p className="h5 font-weight-bold mt-2">
                        {`${item.name || ""} ${item.last_name || ""}`.trim() ||
                          "Sin dato"}
                      </p>
                    </Col>
                    <Col md="3" className="text-center">
                      <small>
                        <p className="text-primary text-center mb-1">Email</p>
                      </small>
                      <p className="h5 font-weight-bold mt-2">
                        {item.email || "Sin dato"}
                      </p>
                    </Col>
                    <Col md="2" className="text-center">
                      <small>
                        <p className="text-primary text-center mb-1">CUIT</p>
                      </small>
                      <p className="h5 font-weight-bold mt-2 number-font">
                        {item.cuit || "Sin dato"}
                      </p>
                    </Col>
                    <Col md="1" className="text-center">
                      <small>
                        <p className="text-primary text-center mb-1">Alta</p>
                      </small>
                      <p className="h6 font-weight-bold mt-2">
                        {item.createdAt
                          ? moment(item.createdAt).format("DD/MM/YY")
                          : "-"}
                      </p>
                    </Col>
                    <Col
                      md="1"
                      className="d-flex align-items-center text-right justify-content-end pr-4"
                    >
                      <GoTriangleRight />
                    </Col>
                  </Row>
                </CustomItemList>
              ))
            ) : (
              <DivEmpty>
                {!spinner ? (
                  <h2 className="font-weight-bold h3 text-center">
                    No hay cuentas hijas para mostrar
                  </h2>
                ) : null}
              </DivEmpty>
            )}
          </ContainerList>
        </Col>
      </Row>
    </Container>
  );
}

export default ParentChildren;
